import React, { useEffect, useState, useCallback } from "react";
import { sendApiRequest } from "../utils/api";
import { useNavigate } from "react-router-dom";

// Images
import EnglishImg from "../assets/ssclogo.png";
import HindiImg from "../assets/ssclogo.png";
import CourtImg from "../assets/courticon.png";
import DefaultImg from "../assets/ssclogo.png";

const OurExams = () => {
  const navigate = useNavigate();
  const [exams, setExams] = useState([]);

  const getLocalExamImage = (title) => {
    const t = title.toLowerCase();
    if (t.includes("english")) return EnglishImg;
    if (t.includes("hindi")) return HindiImg;
    if (t.includes("court")) return CourtImg;
    return DefaultImg;
  };

  const fetchExams = useCallback(async () => {
    try {
      const response = await sendApiRequest("api/exam-categories", {}, "GET");
      if (Array.isArray(response)) {
        setExams(
          response.map((exam) => ({
            id: exam._id,
            title: exam.title,
            description: exam.description,
            image: getLocalExamImage(exam.title),
          }))
        );
      }
    } catch (err) {
      console.error(err);
    }
  }, []);

  useEffect(() => {
    fetchExams();
  }, [fetchExams]);

  return (
    <div className="bg-[#1d3a80] py-10 px-4">
      {/* SECTION TITLE */}
      <h2 className="text-white text-center text-3xl font-bold mb-6">
        Our Courses
      </h2>

      {/* WHITE CONTAINER */}
      <div className="bg-[#f5f7fb] rounded-3xl p-6 max-w-7xl mx-auto">
        <h3 className="text-base font-semibold text-[#0f2a5f] mb-4">
          Popular Courses
        </h3>

        {/* ✅ GRID FIXED HERE */}
        <div
          className="
            grid
            grid-cols-2          /* 📱 Mobile: 2 cards */
            sm:grid-cols-2
            lg:grid-cols-3       /* 💻 Desktop */
            xl:grid-cols-4
            gap-5
          "
        >
          {exams.map((exam) => (
            <div
              key={exam.id}
              className="bg-white rounded-xl shadow-sm hover:shadow-md transition overflow-hidden"
            >
              {/* IMAGE */}
              <img
                src={exam.image}
                alt={exam.title}
                className="w-full h-[120px] sm:h-[130px] object-cover"
              />

              {/* CONTENT */}
              <div className="p-4 text-center">
                <h4 className="text-[14px] sm:text-[15px] font-semibold text-gray-900">
                  {exam.title}
                </h4>

                <p className="text-[11px] sm:text-[12px] text-gray-500 mt-1 mb-3 line-clamp-2">
                  {exam.description}
                </p>

                <button
                  onClick={() => navigate(`/category/${exam.id}`)}
                  className="bg-[#1f4fa3] text-white text-xs px-4 py-1.5 rounded-md
                             hover:bg-[#163a7a] transition"
                >
                  Learn More
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default OurExams;
